import axios from 'axios';

const API = axios.create({
  baseURL: 'http://localhost:3001', // Adresse de ton backend
});

// Exemple : Récupérer les providers Azure
export const getAzureProviders = () => API.get('/azure/providers');

// Exemple : Récupérer le schéma Terraform AzureRM
export const getTerraformSchema = () => API.get('/terraform/schema');

export default API;
